import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Info from '../../../../../../components/channel-configuration/info';
import { Switch } from '../../../../../../components/switch';
import { ChannelGateType, ChannelType } from '../../../../types';
import './index.scss';

type NegativeOutputProps = {
  channel: ChannelType;
  handleSave: (value: boolean) => void;
};

const NegativeOutput: React.FC<NegativeOutputProps> = ({ channel, handleSave }) => {
  const { t } = useTranslation('configuration');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => handleSave(e.target.checked);

  const negativeOutput = !!(channel.data as ChannelGateType).isNegativeOutput;

  return (
    <div className="negative-output">
      <Info title={t('negativeOutput')}>
        <Switch checked={negativeOutput} onChange={handleChange} />
      </Info>
    </div>
  );
};

export default NegativeOutput;
